import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	Grid,
	Typography,
	Button,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from '@material-ui/core';

import { MobileFeatureCard } from './MobileFeatureCard';

const useStyles = makeStyles((theme) => ({
	header: {
		lineHeight: 1.4,
		fontWeight: 700,
		color: '#002D5C',
	},
	title: {
		fontWeight: 700,
		color: theme.workwaveBlue,
		marginLeft: '1.2rem',
		fontSize: '1.3rem',
	},
	card: {
		// border: '1px solid #ECECEE',
		boxShadow: '0px .5px 2px rgba(0, 0, 0, 0.3)',
		borderRadius: '20px',
		cursor: 'pointer',
		background: theme.white,
		transition: 'transform 0.25s, box-shadow 0.75s',
	},
	expanded: {},
	root: {
		'&$expanded': {
			minHeight: 0,
		},
	},
	content: {
		margin: 0,
		'&$expanded': {
			margin: 0,
			minHeight: 'unset',
		},
	},
}));

export const MobileFeatures = ({
	featureSection,
	selectedFeature,
	featureHeader,
	featureRef,
	accentColor,
	featureListCta,
	setFeatureModalOpen,
	noOverview,
	api,
	partnerSectionScroll,
	noCards,
}) => {
	const classes = useStyles();
	const mobileCardRef = useRef(null);
	const [expanded, setExpanded] = useState(0);

	const handleChange = async (index) => {
		await setExpanded(index);
		mobileCardRef?.current?.scrollIntoView({
			behavior: 'smooth',
		});
	};
	return (
		<>
			<Grid
				container
				direction='column'
				justifyContent='center'
				alignItems='center'
				spacing={2}
				style={{ padding: noOverview ? '0 0 0 0' : '0 0 0 0', position: 'relative', zIndex: 3 }}>
				{!noCards ? (
					<Grid item>
						<Typography variant='h4' className={classes.header}>
							{featureHeader}
						</Typography>
					</Grid>
				) : null}

				<div ref={mobileCardRef} />
				{featureSection.map((feature, index) => (
					<MobileFeatureCard
						feature={feature}
						index={index}
						key={index}
						featureRef={featureRef}
						accentColor={accentColor}
						expanded={expanded}
						handleChange={handleChange}
					/>
				))}
				{/* {api ? (
					<Grid item xs={12}>
						<Accordion
							expanded={false}
							className={classes.card}
							onClick={(e) => partnerSectionScroll(e)}
							style={{
								borderRadius: '8px',
								border: '2px solid #E5EAF4',
								boxShadow: '0 10px 40px 0px rgba(0,0,0,0.15)',
								overflow: 'hidden',
							}}>
							<AccordionSummary
								style={{ padding: 0 }}
								classes={{
									content: classes.content,
									expanded: classes.expanded,
									root: classes.root,
								}}>
								<Grid
									container
									direction='row'
									justifyContent='flex-start'
									alignItems='center'>
									<FontAwesomeIcon
										icon={['fad', 'handshake-simple']}
										style={{
											height: '60px',
											width: '60px',
											border: `1px solid #E5EAF4`,
											background: '#E5EAF4',
											padding: '10px',
											color: '#002D5C',
										}}
									/>

									<Typography variant='h5' className={classes.title}>
										API & Software Partners
									</Typography>
								</Grid>
							</AccordionSummary>
							<AccordionDetails>
								<div style={{ width: '100%' }}>sdfs</div>
							</AccordionDetails>
						</Accordion>
					</Grid>
				) : null} */}
			</Grid>
			{!!featureListCta ? (
				<Grid
					container
					direction='row'
					justifyContent='center'
					alignItems='center'>
					<Button
						variant='contained'
						size='medium'
						onClick={(e) => setFeatureModalOpen(true)}
						style={{
							background: accentColor ?? '#002D5C',
							color: 'white',
							margin: '2rem 0',
						}}>
						{featureListCta}
					</Button>
				</Grid>
			) : null}
		</>
	);
};
